import { cloneObject, wrap } from "../utils/utils";
import { isArray } from "lodash";
import JSZip from "jszip";

import dsd from "../classes/clsDSD";

export const addConceptModel = (dsd, Data = {}, onAdd, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadConceptModel(Data)

    dsd.httpConfig.post(`/conceptmodels`, payload, headers)
        .then(response => {
            if (onAdd){
                onAdd(response.data._id)
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
}

export const editConceptModel = (dsd, id = null, Data = {}, onUpdate, onError) => {
    
    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }


    let payload = payloadConceptModel(Data)

    dsd.httpConfig.put(`/conceptmodels/${id}`, payload, headers)
        .then(response => {
            if (onUpdate){
                onUpdate();
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return true;
};


function payloadConceptModel(data){

    let payload = {}
    payload.name = data.name;
    payload.description = data.description;
    payload.namespace = data.namespace;
    payload.prefix = data.prefix;
    payload.proposals = data.proposals;
    payload.status = data.status;

    return payload;

}

function dataConceptModel(data){

    let obj = data;

    return obj;

}

export const getConceptModelVersion = (dsd, id=null, idVersion = null, onLoad=null, onFail=null, representation='dsd', format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/conceptmodels/${id}/version/${idVersion}?`

    if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};

export const getConceptModelVersionConcepts = (dsd, id=null, idVersion = null, onLoad=null, onFail=null, representation='dsd', format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/conceptmodels/${id}/version/${idVersion}/concepts?`

    if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};


export const getConceptModelVersionLinks = (dsd, id=null, idVersion = null, onLoad=null, onFail=null, representation='dsd', format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/conceptmodels/${id}/version/${idVersion}/links?`

    if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};



export const getConceptModel = (dsd, id=null, onLoad=null, onFail=null, representation="dsd", format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/conceptmodels/${id}?`

        if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};

/*
export const zipConceptModel = async function(dsd, ConceptModel){

    const zip = new JSZip();

    let Promises = [];

    let Version = null;
    let idVersion = null;
    if (ConceptModel.Version){
        Version = ConceptModel.Version;
        idVersion = Version._id;
    }

    let nameFolder = `conceptmodel_${ConceptModel._id}`;
    if (Version){
        nameFolder += `_version_${idVersion}`;
    }

    let strConceptModel = JSON.stringify(ConceptModel, null, 4);
    zip.file(`${nameFolder}/dsd.json`, strConceptModel);

    let page = null;
    let index = null;
    let indexGDS = null;
    let site = null;
    let siteGDS = null;

    let csv = null;
    let rdfs = null;
    let dot = null;
    let dotConcepts = null;
    let dotLinks = null;

    let svg = null;
    let svgConcepts = null;
    let svgLinks = null;


    const onDonePage = function(reply){
        page = reply;
        return;
    };

    const onDoneIndex = function(reply){
        index = reply;
        return;
    };

    const onDoneIndexGDS = function(reply){
        indexGDS = reply;
        return;
    };


    const onDoneSite = function(reply){
        site = reply;
        return;
    };

    const onDoneSiteGDS = function(reply){
        siteGDS = reply;
        return;
    };


    const onDoneCsv = function(reply){
        csv = reply;
        return;
    };

    const onDoneRdfs = function(reply){
        rdfs = reply;
        return;
    };

    const onDoneDot = function(reply){
        dot = reply;
        return;
    };

    const onDoneDotConcepts = function(reply){
        dotConcepts = reply;
        return;
    };

    const onDoneDotLinks = function(reply){
        dotLinks = reply;
        return;
    };

    const onDoneSvg = function(reply){
        svg = reply;
        return;
    };

    const onDoneSvgConcepts = function(reply){
        svgConcepts = reply;
        return;
    };

    const onDoneSvgLinks = function(reply){
        svgLinks = reply;
        return;
    };

    Promises.push(getConceptModelVersion(dsd,ConceptModel._id,idVersion, onDonePage, null,'page'));

    Promises.push(getConceptModelVersion(dsd,ConceptModel._id,idVersion, onDoneIndex, null,'page', 'html'));
    Promises.push(getConceptModelVersion(dsd,ConceptModel._id,idVersion, onDoneIndexGDS, null,'page', 'html',{style:'UK Government Design System'}));

    Promises.push(getConceptModelVersion(dsd,ConceptModel._id,idVersion, onDoneSite, null,'site', 'json'));
    Promises.push(getConceptModelVersion(dsd,ConceptModel._id,idVersion, onDoneSiteGDS, null,'site', 'json',{style:'UK Government Design System'}));


    Promises.push(getConceptModelVersion(dsd,ConceptModel._id,idVersion, onDoneCsv, null,'csv'));
    Promises.push(getConceptModelVersion(dsd,ConceptModel._id,idVersion, onDoneRdfs, null,'rdfs'));
    Promises.push(getConceptModelVersion(dsd,ConceptModel._id,idVersion, onDoneDot, null,'dot'));
    Promises.push(getConceptModelVersionConcepts(dsd,ConceptModel._id,idVersion, onDoneDotConcepts, null,'dot'));
    Promises.push(getConceptModelVersionLinks(dsd,ConceptModel._id,idVersion, onDoneDotLinks, null,'dot'));

    Promises.push(getConceptModelVersion(dsd,ConceptModel._id,idVersion, onDoneSvg, null,'image'));
    Promises.push(getConceptModelVersionConcepts(dsd,ConceptModel._id,idVersion, onDoneSvgConcepts, null,'image'));
    Promises.push(getConceptModelVersionLinks(dsd,ConceptModel._id,idVersion, onDoneSvgLinks, null,'image'));


    return(
        Promise.all(Promises)
        .then(async response => {

            if (page){
                zip.file(`${nameFolder}/page.md`, page);
            }

            if (index){
                zip.file(`${nameFolder}/index.html`, index);
            }

            if (indexGDS){
                zip.file(`${nameFolder}/indexGDS.html`, indexGDS);
            }

            if (csv){
                zip.file(`${nameFolder}/conceptmodel.csv`, csv);
            }
            if (rdfs){
                zip.file(`${nameFolder}/conceptmodel.ttl`, rdfs);
            }                

            if (dot){
                zip.file(`${nameFolder}/dot.txt`,dot);
            }

            if (svg){
                zip.file(`${nameFolder}/image.svg`,svg);
            }


            for (let pos=0; pos<ConceptModel.Concepts.length; pos++){
                let Concept = cloneObject(ConceptModel.Concepts[pos]);

                if (Concept.status === 'deprecated'){
                    continue
                }

                Concept.ConceptModel = cloneObject(ConceptModel);
                delete Concept.ConceptModel.Concepts;
                delete Concept.ConceptModel.Links;

                let strConcept = JSON.stringify(Concept,null,4);
                zip.file(`${nameFolder}/concepts/${Concept._id}/dsd.json`, strConcept);

                let dotConcept = dotConcepts && dotConcepts[Concept._id];
                if (dotConcept) zip.file(`${nameFolder}/concepts/${Concept._id}/dot.txt`, dotConcept);

                let svgConcept = svgConcepts && svgConcepts[Concept._id];
                if (svgConcept) zip.file(`${nameFolder}/concepts/${Concept._id}/image.svg`, svgConcept);

            }

            for (let pos=0; pos<ConceptModel.Links.length; pos++){
                let Link = cloneObject(ConceptModel.Links[pos]);

                if (Link.status === 'deprecated'){
                    continue
                }

                Link.ConceptModel = cloneObject(ConceptModel);
                delete Link.ConceptModel.Concepts;
                delete Link.ConceptModel.Links;

                let strLink = JSON.stringify(Link,null,4);
                zip.file(`${nameFolder}/links/${Link._id}/dsd.json`, strLink);

                let dotLink = dotLinks && dotLinks[Link._id];
                if (dotLink) zip.file(`${nameFolder}/links/${Link._id}/dot.txt`, dotLink);

                let svgLink = svgLinks && svgLinks[Link._id];
                if (svgLink) zip.file(`${nameFolder}/links/${Link._id}/image.svg`, svgLink);

            }

            if (site && Array.isArray(site.files)){
                for (const file of site.files){
                    if (file.content != null){
                        zip.file(`${nameFolder}/site/${file.path}`, file.content);
                    }
                }

                zip.file(`${nameFolder}/site/dsd.json`, strConceptModel);

                if (csv){
                    zip.file(`${nameFolder}/site/conceptmodel.csv`, csv);
                }
                if (rdfs){
                    zip.file(`${nameFolder}/site/conceptmodel.ttl`, rdfs);
                }                

                if (dot){
                    zip.file(`${nameFolder}/site/dot.txt`,dot);
                }

                if (svg){
                    zip.file(`${nameFolder}/site/image.svg`,svg);
                }

                for ( const Concept of ConceptModel.Concepts){
                    let svgConcept = svgConcepts && svgConcepts[Concept._id];
                    if (svgConcept) zip.file(`${nameFolder}/site/concepts/${Concept._id}/image.svg`, svgConcept);
                }

                for ( const Link of ConceptModel.Links){
                    let svgLink = svgLinks && svgLinks[Link._id];
                    if (svgLink) zip.file(`${nameFolder}/site/links/${Link._id}/image.svg`, svgLink);
                }

            }


            if (siteGDS && Array.isArray(siteGDS.files)){
                for (const file of siteGDS.files){
                    if (file.content != null){
                        zip.file(`${nameFolder}/siteGDS/${file.path}`, file.content);
                    }
                }

                zip.file(`${nameFolder}/siteGDS/dsd.json`, strConceptModel);

                if (csv){
                    zip.file(`${nameFolder}/siteGDS/conceptmodel.csv`, csv);
                }
                if (rdfs){
                    zip.file(`${nameFolder}/siteGDS/conceptmodel.ttl`, rdfs);
                }                

                if (dot){
                    zip.file(`${nameFolder}/siteGDS/dot.txt`,dot);
                }


                if (svg){
                    zip.file(`${nameFolder}/siteGDS/image.svg`,svg);
                }

                for ( const Concept of ConceptModel.Concepts){
                    let svgConcept = svgConcepts && svgConcepts[Concept._id];
                    if (svgConcept) zip.file(`${nameFolder}/siteGDS/concepts/${Concept._id}/image.svg`, svgConcept);
                }

                for ( const Link of ConceptModel.Links){
                    let svgLink = svgLinks && svgLinks[Link._id];
                    if (svgLink) zip.file(`${nameFolder}/siteGDS/links/${Link._id}/image.svg`, svgLink);
                }

            }

            const zipData = await zip.generateAsync({
                type: "blob",
                streamFiles: true,
            })
        
            return zipData;    

        })
    )

}
*/
// === Concept functions ===



export const addConcept = (dsd, idConceptModel = null, Data = {}, onAdd, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadConcept(Data)

    dsd.httpConfig.post(`/conceptmodels/${idConceptModel}/concepts`, payload, headers)
        .then(response => {
            if (onAdd){
                onAdd(response.data._id)
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
}

export const editConcept = (dsd, id = null, Data = {}, onUpdate, onError) => {
    
    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }


    let payload = payloadConcept(Data)

    let idConceptModel = null;
    if (Data.ConceptModel) {
        idConceptModel = Data.ConceptModel._id;
    }

    dsd.httpConfig.put(`/conceptmodels/${idConceptModel}/concepts/${id}`, payload, headers)
        .then(response => {
            if (onUpdate){
                onUpdate();
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return true;
};

function payloadConcept(data){

    let payload = {}
    payload.name = data.name;
    payload.description = data.description;
    payload.notes = data.notes;
    payload.proposals = data.proposals;
    payload.status = data.status;
    payload.SuperConcepts = data.SuperConcepts;

    return payload;

}

function dataConcept(data){

    let Concept = data;

    return Concept;

}

export const getConcept = (dsd, id=null, onLoad=null, onFail=null, representation="dsd", format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/concepts/${id}?`

        if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

};

export const listConcepts = (dsd, Filters={}, onLoad, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/concepts"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idUser){
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.status){
        urlAPI += `status=${encodeURIComponent(Filters.status)}&`;
    }

    if (Filters.idConceptModel){
        urlAPI += `idConceptModel=${encodeURIComponent(Filters.idConceptModel)}&`;
    }

    if (Filters.idSubConcept){
        urlAPI += `idSubConcept=${encodeURIComponent(Filters.idSubConcept)}&`;
    }

    if (Filters.idNarrative){
        urlAPI += `idNarrative=${encodeURIComponent(Filters.idNarrative)}&`;
    }

    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {
            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
                arr.push(dataConcept(response.data[pos]));
            }
            if (onLoad){
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
};

export const listConceptLinks = (dsd, Filters={}, onLoad, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/conceptlinks"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idConceptModel){
        urlAPI += `idConceptModel=${encodeURIComponent(Filters.idConceptModel)}&`;
    }

    if (Filters.idConcept){
        urlAPI += `idConcept=${encodeURIComponent(Filters.idConcept)}&`;
    }

    if (Filters.idLink){
        urlAPI += `idLink=${encodeURIComponent(Filters.idLink)}&`;
    }

    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {
            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
                arr.push(dataConceptLink(response.data[pos]));
            }
            if (onLoad){
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
}

function dataConceptLink(data){

    let obj = data;

    return obj;

}

// === Link functions ===

export const addLink = (dsd, idConceptModel = null, Data = {}, onAdd, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadLink(Data)

    dsd.httpConfig.post(`/conceptmodels/${idConceptModel}/links`, payload, headers)
        .then(response => {
            if (onAdd){
                onAdd(response.data._id)
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
}

export const editLink = (dsd, idConceptModel = null, id = null, Data = {}, onUpdate, onError) => {
    
    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }


    let payload = payloadLink(Data)

    dsd.httpConfig.put(`/conceptmodels/${idConceptModel}/links/${id}`, payload, headers)
        .then(response => {
            if (onUpdate){
                onUpdate();
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return true;
};

export const getLink = (dsd, id=null, onLoad=null, onFail=null, representation="dsd", format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/links/${id}?`

        if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

};

export const listLinks = (dsd, Filters={}, onLoad, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/links"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idUser){
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.status){
        urlAPI += `status=${encodeURIComponent(Filters.status)}&`;
    }

    if (Filters.idConceptModel){
        urlAPI += `idConceptModel=${encodeURIComponent(Filters.idConceptModel)}&`;
    }

    if (Filters.idConcept){
        urlAPI += `idConcept=${encodeURIComponent(Filters.idConcept)}&`;
    }

    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {
            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
                arr.push(dataLink(response.data[pos]));
            }
            if (onLoad){
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
            console.log(e);
        });

    return;
};

function payloadLink(data){

    let payload = {}
    payload.name = data.name;

    payload.label = data.label;
    payload.inverseLabel = data.inverseLabel;

    payload.idConceptFrom = data.idConceptFrom;
    payload.idConceptTo = data.idConceptTo;

    payload.description = data.description;
    payload.notes = data.notes;
    payload.proposals = data.proposals;
    payload.status = data.status;

    return payload;

}

function dataLink(data){

    let obj = data;

    return obj;

}


export const listConceptModels = (dsd, Filters={}, onLoad, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/conceptmodels"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idUser){
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.scope){
        urlAPI += `scope=${encodeURIComponent(Filters.scope)}&`;
    }

    if (Filters.status){
        urlAPI += `status=${encodeURIComponent(Filters.status)}&`;
    }

    if (Filters.search){
        urlAPI += `search=${encodeURIComponent(Filters.search)}&`;
    }

    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {
            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
                arr.push(dataConceptModel(response.data[pos]));
            }
            if (onLoad){
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
};

export const zipConceptModel = async function(dsd, id, idVersion){

    const zip = new JSZip();

    const assets = await assetsConceptModelVersion(dsd, id, idVersion);

    const ConceptModel = assets["dsd.json"];

    let nameFolder = `conceptmodel_${id}`;
    if (idVersion){
        nameFolder += `_version_${idVersion}`;
    }

    for (const idAsset in assets){
        let assetValue = assets[idAsset];

        // Serialize JSON-like objects before zipping.
        if (
            typeof assetValue === 'object' &&
            assetValue !== null &&
            !(assetValue instanceof Blob) &&
            !(assetValue instanceof ArrayBuffer) &&
            !(assetValue instanceof Uint8Array)
        ) {
            assetValue = JSON.stringify(assetValue, null, 4);
        }

        zip.file(`${nameFolder}/${idAsset}`, assetValue);

// repeat for /site and /siteGDS


        if (idAsset.startsWith("site/") || idAsset.startsWith("siteGDS/")) {
            continue;
        }

        switch (idAsset) {
            case "page.md":
            case "index.html":
            case "indexGDS.html":
                break; // Skip these files for /site and /siteGDS
            default:{
                zip.file(`${nameFolder}/site/${idAsset}`, assetValue);
                zip.file(`${nameFolder}/siteGDS/${idAsset}`, assetValue);
            }
        }
    }

    const zipData = await zip.generateAsync({
        type: "blob",
        streamFiles: true,
    });

    return zipData;

};


export const assetsConceptModelVersion = async function(dsd, idConceptModel, idVersion){

    const assets = {};

    let Promises = [];

    let doc = null;
    let page = null;
    let index = null;
    let indexGDS = null;

    let site = null;
    let siteGDS = null;


    let svg = null;
    let svgConcepts = null;
    let svgLinks = null;


    let dot = null;

    let csv = null;
    let rdfs = null;

    let ConceptModel = null


    const onDoneDoc = function(reply){
        doc = reply;
        return;
    };


    const onDonePage = function(reply){
        page = reply;
        return;
    };


    const onDoneIndex = function(reply){
        index = reply;
        return;
    };

    const onDoneIndexGDS = function(reply){
        indexGDS = reply;
        return;
    };


    const onDoneSite = function(reply){
        site = reply;
        return;
    };

    const onDoneSiteGDS = function(reply){
        siteGDS = reply;
        return;
    };


    const onDoneCsv = function(reply){
        csv = reply;
        return;
    };

    const onDoneRdfs = function(reply){
        rdfs = reply;
        return;
    };


    const onDoneSvg = function(reply){
        svg = reply;
        return;
    };

    const onDoneSvgConcepts = function(reply){
        svgConcepts = reply;
        return;
    };

    const onDoneSvgLinks = function(reply){
        svgLinks = reply;
        return;
    };


    const onDoneDot = function(reply){
        dot = reply;
        return;
    };


    Promises.push(getConceptModelVersion(dsd,idConceptModel,idVersion, onDoneDoc));
    
    Promises.push(getConceptModelVersion(dsd,idConceptModel,idVersion, onDonePage, null,'page'));
    Promises.push(getConceptModelVersion(dsd,idConceptModel,idVersion, onDoneIndex, null,'page', 'html'));

    Promises.push(getConceptModelVersion(dsd,idConceptModel,idVersion, onDoneIndexGDS, null,'page', 'html',{style:'UK Government Design System'}));

    Promises.push(getConceptModelVersion(dsd,idConceptModel,idVersion, onDoneSite, null,'site', 'json'));
    Promises.push(getConceptModelVersion(dsd,idConceptModel,idVersion, onDoneSiteGDS, null,'site', 'json',{style:'UK Government Design System'}));


    Promises.push(getConceptModelVersion(dsd,idConceptModel,idVersion, onDoneDot, null,'dot'));
    Promises.push(getConceptModelVersion(dsd,idConceptModel,idVersion, onDoneCsv, null,'csv'));
    Promises.push(getConceptModelVersion(dsd,idConceptModel,idVersion, onDoneRdfs, null,'rdfs'));
    Promises.push(getConceptModelVersion(dsd,idConceptModel,idVersion, onDoneSvg, null,'image', 'svg'));
    Promises.push(getConceptModelVersion(dsd,idConceptModel,idVersion, onDoneSvgConcepts, null,'image', 'svgConcepts'));
    Promises.push(getConceptModelVersionConcepts(dsd,idConceptModel,idVersion, onDoneSvgConcepts, null,'image'));
    Promises.push(getConceptModelVersionLinks(dsd,idConceptModel,idVersion, onDoneSvgLinks, null,'image'));



    return(
        Promise.all(Promises)
        .then(async response => {

            if (doc){
                assets["dsd.json"] = doc;
                ConceptModel = cloneObject(doc);
            }

            if (page){
                assets["page.md"] = page;
            }
            if (index){
                assets["index.html"] = index;
            }
            
            if (indexGDS){
                assets["indexGDS.html"] = indexGDS;
            }


            if (dot){
                assets["dot.txt"] = dot;
            }

            if (svg){
                assets["image.svg"] = svg;
            }

            if (csv){
                assets["conceptmodel.csv"] = csv;
            }

            if (rdfs){
                assets["conceptmodel.ttl"] = rdfs;
            }

            for (const idConcept in svgConcepts){
                let svgConcept = svgConcepts[idConcept];
                if (svgConcept) assets[`concepts/${idConcept}/image.svg`] = svgConcept;
            }

            for (const idLink in svgLinks){
                let svgLink = svgLinks[idLink];
                if (svgLink) assets[`links/${idLink}/image.svg`] = svgLink;
            }

            if (site && site.files){
                for (const file of site.files){
                    if (file.content != null){
                        assets[`site/${file.path}`] = file.content;
                    }
                }
            }

            if (siteGDS && siteGDS.files){
                for (const file of siteGDS.files){
                    if (file.content != null){
                        assets[`siteGDS/${file.path}`] = file.content;
                    }
                }
            }

            return assets;    

        })
    )

};